import { render, staticRenderFns } from "./PromotionPocApprovalForm.vue?vue&type=template&id=366b2e14&"
import script from "./PromotionPocApprovalForm.vue?vue&type=script&lang=js&"
export * from "./PromotionPocApprovalForm.vue?vue&type=script&lang=js&"
import style0 from "../scss/app.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "../scss/page/PromoRequestForm.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports